import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import CollectionPointComponent from '../components/collection-point.component';
import { collectionPoints } from '../../../../../../redux/collection-points/action';
import { selectCollectionPointsQueryItems } from '../../../../../../redux/collection-points/selector';

const ManagementCollectionPoint = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const collectionPointQuery = useSelector(selectCollectionPointsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    selectedCollection,
    setSelectedCollection
  ] = useState<any>([])
  const fetchCollectionPointQueryById= ()=>{
    dispatch(collectionPoints.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/collection-points/query`,entity:'collectionPoints',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedCollection({ ...selectedCollection, [field]: event })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedCollection({ ...selectedCollection, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  
  useEffect(
    () => {
            if (parmas?.id > 0) {
                fetchCollectionPointQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
      
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedCollection(collectionPointQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: collectionPointQuery?.result?.items?.PrimaryAddress,
            BillingAddress: collectionPointQuery?.result?.items?.BillingAddress,
            ShippingAddress: collectionPointQuery?.result?.items?.ShippingAddress})
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const collectionPointData= {
   
        CollectionPointInfo: {
            Id: selectedCollection?.CollectionPointInfo?.Id || 0,
            Name: selectedCollection?.CollectionPointInfo?.Name,
            PhoneNumber: selectedCollection?.CollectionPointInfo?.PhoneNumber,
          
          },
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedCollection?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedCollection?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress
      }
      if (parmas?.id > 0) {
     dispatch(collectionPoints.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/collection-points`,entity:'collectionPoints',jsonData:{
          
    Records: [
        collectionPointData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(collectionPoints.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/collection-points`,entity:'collectionPoints',jsonData:{
            
        Records: [
            collectionPointData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/collection-points')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <CollectionPointComponent 
          back={back}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          handleFormSubmit={handleFormSubmit}
          onInnerFormChange={handleInnerFormChange}
          selectedAddress={selectedAddress}
          selectedCollection={selectedCollection}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementCollectionPoint;